
const createStarexProduct = (data: any) => ({
  ...data,
  price: 0,
  status: '재고있음',
  category: 'HYUNDAI STAREX',
  colors: data.colors || ['#808080'],
  features: [
    { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환성' },
    { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    { icon: 'ri-star-line', title: '고품질', description: '내구성 보장' },
    { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '안심 사용' },
  ],
  craftStory: {
    image: `https://public.readdy.ai/ai/img_res/90d9aafa5f90b4e2cb9ebd506fbc2063.jpg${data.id}_craft&orientation=landscape`,
    story: `STAREX H1의 ${data.description}입니다.`,
    details: ['순정 규격 제작', '고품질 소재', '내구성 보장', '완벽한 호환'],
  },
});

export const starexProducts = [
  createStarexProduct({
    id: 'STA001',
    name: 'STA001',
    subcategory: '램프',
    partNumber: '92101-4H000 L / 92102-4H000 R',
    description: 'HEAD LAMP',
    fullDescription:
      '현대 스타렉스 H1에 호환되는 헤드 램프입니다. 품번 92101-4H000 L / 92102-4H000 R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '12V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20headlamp%20clear%20lens%20chrome%20housing%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta001main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20headlight%20assembly%20clear%20lens%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta001img1&orientation=portrait',
    ],
    colors: ['#C0C0C0'],
  }),
  createStarexProduct({
    id: 'STA001C',
    name: 'STA001C',
    subcategory: '램프',
    partNumber: '92101-4H000C L / 92102-4H000C R',
    description: 'HEAD LAMP CHROME',
    fullDescription:
      '현대 스타렉스 H1에 호환되는 크롬 헤드 램프입니다. 품번 92101-4H000C L / 92102-4H000C R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '12V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20chrome%20headlamp%20shiny%20chrome%20housing%20clear%20lens%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta001cmain&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20chrome%20headlight%20assembly%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta001cimg1&orientation=portrait',
    ],
    colors: ['#C0C0C0'],
  }),
  createStarexProduct({
    id: 'STA002',
    name: 'STA002',
    subcategory: '램프',
    partNumber: '92201-4H000 L / 92202-4H000 R',
    description: 'FOG LAMP',
    fullDescription:
      '현대 스타렉스 H1에 호환되는 포그 램프입니다. 품번 92201-4H000 L / 92202-4H000 R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '12V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20fog%20lamp%20round%20clear%20lens%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta002main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20fog%20light%20round%20lens%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta002img1&orientation=portrait',
    ],
    colors: ['#FFFF00'],
  }),
  createStarexProduct({
    id: 'STA003',
    name: 'STA003',
    subcategory: '램프',
    partNumber: '92401-4H000 L / 92402-4H000 R',
    description: 'TAIL LAMP',
    fullDescription:
      '현대 스타렉스 H1에 호환되는 테일 램프입니다. 품번 92401-4H000 L / 92402-4H000 R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '12V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20tail%20lamp%20red%20rear%20light%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta003main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20tail%20light%20red%20rear%20lamp%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta003img1&orientation=portrait',
    ],
    colors: ['#FF0000'],
  }),
  createStarexProduct({
    id: 'STA004',
    name: 'STA004',
    subcategory: '외장',
    partNumber: '86560-4H000',
    description: 'GRILLE',
    fullDescription:
      '현대 스타렉스 H1에 호환되는 그릴입니다. 품번 86560-4H000.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20front%20grille%20black%20chrome%20mesh%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta004main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20front%20grille%20black%20chrome%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta004img1&orientation=portrait',
    ],
  }),
  createStarexProduct({
    id: 'STA005',
    name: 'STA005',
    subcategory: '외장',
    partNumber: '87610-4H000 L / 87620-4H000 R',
    description: 'MIRROR',
    fullDescription:
      '현대 스타렉스 H1에 호환되는 사이드 미러입니다. 품번 87610-4H000 L / 87620-4H000 R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20side%20mirror%20black%20housing%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta005main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20side%20mirror%20black%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta005img1&orientation=portrait',
    ],
    colors: ['#000000'],
  }),
  createStarexProduct({
    id: 'STA006',
    name: 'STA006',
    subcategory: '외장',
    partNumber: '86811-4H000 L / 86812-4H000 R',
    description: 'INNER FENDER',
    fullDescription:
      '현대 스타렉스 H1에 호환되는 이너 펜더입니다. 품번 86811-4H000 L / 86812-4H000 R. 좌우 구분 장착이 필요합니다.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20inner%20fender%20liner%20plastic%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta006main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20inner%20fender%20liner%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta006img1&orientation=portrait',
    ],
  }),
  createStarexProduct({
    id: 'STA007',
    name: 'STA007',
    subcategory: '외장',
    partNumber: '64101-4H000',
    description: 'RADIATOR SUPPORT',
    fullDescription:
      '현대 스타렉스 H1에 호환되는 라디에이터 서포트입니다. 품번 64101-4H000.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20radiator%20support%20frame%20metal%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta007main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20radiator%20support%20metal%20frame%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta007img1&orientation=portrait',
    ],
  }),
  createStarexProduct({
    id: 'STA008',
    name: 'STA008',
    subcategory: '외장',
    partNumber: '66400-4H010',
    description: 'HOOD',
    fullDescription:
      '현대 스타렉스 H1에 호환되는 후드입니다. 품번 66400-4H010.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20hood%20bonnet%20white%20metal%20body%20panel%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta008main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20hood%20bonnet%20white%20metal%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta008img1&orientation=portrait',
    ],
  }),
  createStarexProduct({
    id: 'STA009',
    name: 'STA009',
    subcategory: '외장',
    partNumber: '66311/21-4H401',
    description: 'FENDER',
    fullDescription:
      '현대 스타렉스 H1에 호환되는 펜더입니다. 품번 66311/21-4H401.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20fender%20panel%20white%20metal%20body%20part%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta009main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20fender%20panel%20white%20metal%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta009img1&orientation=portrait',
    ],
  }),
  createStarexProduct({
    id: 'STA010',
    name: 'STA010',
    subcategory: '외장',
    partNumber: '-',
    description: 'DOOR',
    fullDescription:
      '현대 스타렉스 H1에 호환되는 도어입니다.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20door%20panel%20white%20metal%20body%20part%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta010main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20door%20panel%20white%20metal%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta010img1&orientation=portrait',
    ],
  }),
  createStarexProduct({
    id: 'STA011',
    name: 'STA011',
    subcategory: '외장',
    partNumber: '-',
    description: 'GATE',
    fullDescription:
      '현대 스타렉스 H1에 호환되는 게이트입니다.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20rear%20gate%20tailgate%20white%20metal%20body%20part%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta011main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20rear%20gate%20tailgate%20white%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta011img1&orientation=portrait',
    ],
  }),
  createStarexProduct({
    id: 'STA012',
    name: 'STA012',
    subcategory: '램프',
    partNumber: '92101/2-4H600',
    description: 'HEAD LAMP',
    fullDescription:
      '현대 스타렉스 H1 신형에 호환되는 헤드 램프입니다. 품번 92101/2-4H600.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '12V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20new%20model%20headlamp%20projector%20lens%20clear%20housing%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta012main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20new%20headlight%20projector%20lens%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta012img1&orientation=portrait',
    ],
    colors: ['#C0C0C0'],
  }),
  createStarexProduct({
    id: 'STA013',
    name: 'STA013',
    subcategory: '램프',
    partNumber: '92401/2-4H040',
    description: 'TAIL LAMP',
    fullDescription:
      '현대 스타렉스 H1 신형에 호환되는 테일 램프입니다. 품번 92401/2-4H040.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '12V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20new%20model%20tail%20lamp%20red%20rear%20light%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta013main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20new%20tail%20light%20red%20rear%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta013img1&orientation=portrait',
    ],
    colors: ['#FF0000'],
  }),
  createStarexProduct({
    id: 'STA014',
    name: 'STA014',
    subcategory: '램프',
    partNumber: '92101/2-4H600',
    description: 'FOG LAMP',
    fullDescription:
      '현대 스타렉스 H1 신형에 호환되는 포그 램프입니다. 품번 92101/2-4H600.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '12V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20new%20model%20fog%20lamp%20round%20clear%20lens%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta014main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20new%20fog%20light%20round%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta014img1&orientation=portrait',
    ],
    colors: ['#FFFF00'],
  }),
  createStarexProduct({
    id: 'STA015',
    name: 'STA015',
    subcategory: '외장',
    partNumber: '86512-4H710',
    description: 'FRONT BUMPER LOWER',
    fullDescription:
      '현대 스타렉스 H1에 호환되는 프론트 범퍼 로워입니다. 품번 86512-4H710.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20front%20bumper%20lower%20section%20black%20plastic%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta015main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20front%20bumper%20lower%20black%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta015img1&orientation=portrait',
    ],
  }),
  createStarexProduct({
    id: 'STA016',
    name: 'STA016',
    subcategory: '외장',
    partNumber: '86585-4H700',
    description: 'FRONT BUMPER GRILLE',
    fullDescription:
      '현대 스타렉스 H1에 호환되는 프론트 범퍼 그릴입니다. 품번 86585-4H700.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20front%20bumper%20grille%20mesh%20black%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta016main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20front%20bumper%20grille%20mesh%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta016img1&orientation=portrait',
    ],
  }),
  createStarexProduct({
    id: 'STA017',
    name: 'STA017',
    subcategory: '외장',
    partNumber: '66400-4H500',
    description: 'HOOD',
    fullDescription:
      '현대 스타렉스 H1 신형에 호환되는 후드입니다. 품번 66400-4H500.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20new%20model%20hood%20bonnet%20white%20metal%20body%20panel%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta017main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20new%20hood%20bonnet%20white%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta017img1&orientation=portrait',
    ],
  }),
  createStarexProduct({
    id: 'STA018',
    name: 'STA018',
    subcategory: '외장',
    partNumber: '66311/21-4H600',
    description: 'FENDER',
    fullDescription:
      '현대 스타렉스 H1 신형에 호환되는 펜더입니다. 품번 66311/21-4H600.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20new%20model%20fender%20panel%20white%20metal%20body%20part%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta018main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20new%20fender%20panel%20white%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=sta018img1&orientation=portrait',
    ],
  }),
  createStarexProduct({
    id: 'STA019',
    name: 'STA019',
    subcategory: '외장',
    partNumber: '-',
    description: 'MIRROR',
    fullDescription:
      '현대 스타렉스 H1 신형에 호환되는 사이드 미러입니다.',
    compatibleVehicles: ['STAREX', 'STAREX H1'],
    voltage: '-',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20H1%20van%20new%20model%20side%20mirror%20black%20housing%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=sta019main&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20new%20side%20mirror%20black%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=1000&seq=sta019img1&orientation=portrait',
    ],
    colors: ['#000000'],
  }),
  createStarexProduct({
    id: 'SRX05-001A',
    name: 'SRX05-001A',
    subcategory: '램프',
    partNumber: 'L92405-4A600',
    description: 'BACK LAMP',
    fullDescription:
      '현대 스타렉스 2005년식에 호환되는 백 램프입니다. 품번 L92405-4A600.',
    compatibleVehicles: ['STAREX', 'STAREX 2005'],
    voltage: '12V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%202005%20van%20back%20lamp%20rear%20light%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=srx05001amain&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20back%20lamp%20rear%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=srx05001aimg1&orientation=portrait',
    ],
    colors: ['#FF0000'],
  }),
  createStarexProduct({
    id: 'SRX05-002B',
    name: 'SRX05-002B',
    subcategory: '램프',
    partNumber: 'L92405-4A600',
    description: 'TAIL CORNER LAMP',
    fullDescription:
      '현대 스타렉스 2005년식에 호환되는 테일 코너 램프입니다. 품번 L92405-4A600.',
    compatibleVehicles: ['STAREX', 'STAREX 2005'],
    voltage: '12V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%202005%20van%20tail%20corner%20lamp%20amber%20clear%20lens%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=srx05002bmain&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%20van%20tail%20corner%20light%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=srx05002bimg1&orientation=portrait',
    ],
    colors: ['#FF8C00'],
  }),
  createStarexProduct({
    id: 'SRX03-001A',
    name: 'SRX03-001A',
    subcategory: '램프',
    partNumber: 'L92403-4A500',
    description: 'BACK LAMP',
    fullDescription:
      '현대 스타렉스 2003년식에 호환되는 백 램프입니다. 품번 L92403-4A500.',
    compatibleVehicles: ['STAREX', 'STAREX 2003'],
    voltage: '12V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%202003%20van%20back%20lamp%20rear%20light%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=srx03001amain&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%202003%20van%20back%20lamp%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=srx03001aimg1&orientation=portrait',
    ],
    colors: ['#FF0000'],
  }),
  createStarexProduct({
    id: 'SRX03-002C',
    name: 'SRX03-002C',
    subcategory: '램프',
    partNumber: 'L92401-4A500',
    description: 'TAIL CORNER LAMP',
    fullDescription:
      '현대 스타렉스 2003년식에 호환되는 테일 코너 램프입니다. 품번 L92401-4A500.',
    compatibleVehicles: ['STAREX', 'STAREX 2003'],
    voltage: '12V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%202003%20van%20tail%20corner%20lamp%20clear%20lens%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=srx03002cmain&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%202003%20van%20tail%20corner%20light%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=srx03002cimg1&orientation=portrait',
    ],
    colors: ['#FF8C00'],
  }),
  createStarexProduct({
    id: 'SRX03-003A',
    name: 'SRX03-003A',
    subcategory: '램프',
    partNumber: 'L92101-4A500',
    description: 'HEAD LAMP',
    fullDescription:
      '현대 스타렉스 2003년식에 호환되는 헤드 램프입니다. 품번 L92101-4A500.',
    compatibleVehicles: ['STAREX', 'STAREX 2003'],
    voltage: '12V',
    image:
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%202003%20van%20headlamp%20clear%20lens%20chrome%20housing%20automotive%20replacement%20part%20on%20clean%20white%20background%20professional%20product%20photography%20studio%20lighting%20high%20detail&width=800&height=1000&seq=srx03003amain&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Starex%202003%20van%20headlight%20on%20white%20background%20automotive%20product%20photography%20professional&width=800&height=1000&seq=srx03003aimg1&orientation=portrait',
    ],
    colors: ['#C0C0C0'],
  }),
];
